import { useEffect, useState } from 'react';

export const CHART_VIEW_OPTIONS = [
  { label: 'Default', value: 'default' },
  { label: 'Bar chart', value: 'bar' },
  { label: 'Pie chart', value: 'pie' },
];

function isAllowedView(view, allowedViews) {
  return allowedViews.some((option) => option.value === view);
}

export function useChartView(storageKey, defaultView = 'default', allowedViews = CHART_VIEW_OPTIONS) {
  const [view, setView] = useState(() => {
    try {
      const saved = typeof window !== 'undefined' ? window.localStorage.getItem(storageKey) : null;
      if (isAllowedView(saved, allowedViews)) {
        return saved;
      }
    } catch {
      // ignore storage errors
    }
    return defaultView;
  });

  useEffect(() => {
    if (!isAllowedView(view, allowedViews)) {
      setView(defaultView);
    }
  }, [allowedViews, defaultView, view]);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(storageKey, view);
      }
    } catch {
      // ignore storage errors
    }
  }, [storageKey, view]);

  return [view, setView];
}
